import {IRootScopeService} from "angular";
import {AuthEvents} from "./security-module";
import security from "./security-services";

export default function onAuthFailed($rootScope: IRootScopeService, AUTH_EVENTS: AuthEvents, security: security) {
    $rootScope.$on(AUTH_EVENTS.AUTH_FAILED, function() {
        security.startLogin();
    });
}

onAuthFailed.$inject = ['$rootScope', 'AUTH_EVENTS', 'security'];
